var map = {
	"./back.svg": 4,
	"./cam.svg": 5,
	"./clear.svg": 6,
	"./cw.svg": 7,
	"./email.svg": 8,
	"./facebook-negative.svg": 9,
	"./fullscreen.svg": 10,
	"./heart-negative.svg": 11,
	"./horoscope/mdi_zodiac-aquarius.svg": 12,
	"./horoscope/mdi_zodiac-aries.svg": 13,
	"./horoscope/mdi_zodiac-cancer.svg": 14,
	"./horoscope/mdi_zodiac-capricorn.svg": 15,
	"./horoscope/mdi_zodiac-gemini.svg": 16,
	"./horoscope/mdi_zodiac-leo.svg": 17,
	"./horoscope/mdi_zodiac-libra.svg": 18,
	"./horoscope/mdi_zodiac-pisces.svg": 19,
	"./horoscope/mdi_zodiac-sagittarius.svg": 20,
	"./horoscope/mdi_zodiac-scorpio.svg": 21,
	"./horoscope/mdi_zodiac-taurus.svg": 22,
	"./horoscope/mdi_zodiac-virgo.svg": 23,
	"./icon_facebook.svg": 24,
	"./icon_instagram.svg": 25,
	"./icon_linkedin.svg": 26,
	"./icon_twitter.svg": 27,
	"./icon_whatsapp.svg": 28,
	"./instagram-negative.svg": 29,
	"./linkedin-negative.svg": 30,
	"./logo-cb-color-large.svg": 31,
	"./logo-cb-full-white.svg": 32,
	"./logo-cb-full.svg": 33,
	"./logo-cb-white-large.svg": 34,
	"./logo-cw.svg": 35,
	"./menu.svg": 36,
	"./message.svg": 37,
	"./play-arrow.svg": 38,
	"./playBtn.svg": 39,
	"./relation.svg": 40,
	"./search-slim.svg": 41,
	"./success.svg": 42,
	"./twitter-negative.svg": 43,
	"./user.svg": 44,
	"./whatsapp-negative.svg": 45,
	"./youtube-negative.svg": 46
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3;